var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text)?_c('div',{staticClass:"info-status d-flex flex-row align-items-center",class:_vm.status},[_c('i-icon',{class:_vm.status === 'success' ? 'i-text-success-100' : 'i-text-error-100',attrs:{"symbol":_vm.status === 'success' ? 'small-check-circle' : 'small-alert-circle',"size":16}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }